import { render, staticRenderFns } from "./ArrobaMedellinFooter.html?vue&type=template&id=8d7aea42&scoped=true&external"
import script from "./ArrobaMedellinFooter.vue?vue&type=script&lang=js"
export * from "./ArrobaMedellinFooter.vue?vue&type=script&lang=js"
import style0 from "./ArrobaMedellinFooter.scss?vue&type=style&index=0&id=8d7aea42&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7aea42",
  null
  
)

export default component.exports